<template>
  <a-popover
    v-model="visible"
    :trigger="trigger"
    placement="bottom"
    @visibleChange="visibleChangeHandle"
  >
    <div
      slot="content"
      class="container"
    >
      <div
        v-if="showSearch"
        class="search"
      >
        <a-input-search
          ref="searchInput"
          v-model="keyword"
          :placeholder="searchPlaceholder"
          @search="searchHandle"
        >
          <i
            slot="enterButton"
            class="iconfont iconicon-test45"
          />
        </a-input-search>
      </div>
      <div class="path">
        <span
          class="tag"
          @click="clickTagHandle(0)"
        >
          {{ $t('message["904"]') }}
        </span>
        <span
          v-for="(item, index) in value1"
          :key="item[fieldKey]"
          class="tag"
          @click="clickTagHandle(index + 1)"
        >
          {{ item[fieldName] }}
        </span>
        <span
          v-if="value2"
          class="tag last"
        >
          {{ value2[fieldName] }}
        </span>
      </div>
      <a-spin
        class="main"
        :spinning="loading"
      >
        <div
          v-if="loading"
          class="fetching"
        />
        <div
          v-else-if="empty"
          class="empty"
        >
          <i class="iconfont iconicon-test38 logo-icon" />
          <p class="empty-text">
            {{ $t('message["1548"]') }}
          </p>
          <div
            v-if="showReportBox"
            class="report-box"
          >
            <p>{{ $t('message["1098"]') }}？</p>
            <div class="btns">
              <a-button
                type="primary"
                @click="handleReport"
              >
                {{ $t('message["1092"]') }}
              </a-button>
              <a-button @click="showReportBox = false">
                {{ $t('message["308"]') }}
              </a-button>
            </div>
          </div>
          <div
            v-if="reportSuccess"
            class="report-result"
          >
            <p class="report-success">
              {{ $t('message["1473"]') }}
            </p>
          </div>
        </div>
        <template v-else>
          <ul
            v-if="!isSearch"
            ref="ul"
            class="list scroll_bar_beautify_ff"
          >
            <li
              v-for="item in lists"
              :key="item[fieldKey]"
              class="item"
              :class="{selected: value2 ? item[fieldKey] === value2[fieldKey] : false}"
              @click="clickItemHandle(item)"
            >
              {{ item[fieldName ] }}
              <span
                v-if="item.country_code !== 'CHN' && item.en_name"
                class="en-name"
              >（{{ item.en_name }}）</span>
              <a-icon
                v-if="hasChild(item)"
                class="more"
                type="right"
              />
            </li>
          </ul>
          <ul
            v-else
            class="list"
          >
            <li
              v-for="(item, index) in searchLists"
              :key="searchs[index].key"
              class="item"
              @click="clickSearchItemHandle(item)"
            >
              <span v-html="searchs[index].html" />
            </li>
          </ul>
        </template>
      </a-spin>
    </div>
    <slot />
  </a-popover>
</template>

<script>
import i18n from '@/lib/language'
export default {
  props: {
    trigger: {
      type: String,
      default: 'click'
    },
    searchPlaceholder: {
      type: String,
      default: i18n.t('message["774"]')
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    fieldKey: {
      type: String,
      default: 'code'
    },
    fieldName: {
      type: String,
      default: 'name'
    },
    hasChild: {
      type: Function,
      default: () => true
    },
    getData: {
      type: Function,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    searchData: {
      type: Function,
      default: () => []
    },
    reportSearch: {
      type: Function,
      default: () => {}
    },
    hideOnComplete: {
      type: Boolean,
      default: true
    },
    language: {
      type: Number,
      default: 0
    },
    disabled: { // 设置为false时，点击地区的输入框，不能弹出选择的浮层
      type: Boolean,
      default: false
    }
  },
  data () {
    const { defaultValue } = this
    return {
      visible: false,
      keyword: '',
      isSearch: false,
      value1: defaultValue.concat([]),
      value2: null,
      lists: [],
      searchLists: [],
      loading: false,
      showReportBox: false,
      reportSuccess: false
    }
  },
  computed: {
    empty () {
      if (this.isSearch) {
        return !this.searchLists.length
      } else {
        return !this.lists.length
      }
    },
    searchs () {
      const { fieldKey, fieldName, keyword } = this
      const { searchLists = [] } = this
      return searchLists.map(arr => {
        let htmlArr = arr.map((item, i) => {
          let { name = '', en_name: enName = '' } = item[fieldName]
          let text = ''
          let isChinese = /.*[\u4e00-\u9fa5]+.*$/.test(keyword)
          if (isChinese) { // 搜索输入的是中文
            name = name.replace(keyword, `<span style="color: red">${keyword}</span>`)
            if (i === arr.length - 1 && enName) {
              text = `${name}(${enName})`
            } else {
              text = `${name}`
            }
          } else { // 非中文
            if (i === arr.length - 1 && enName) {
              enName = enName.replace(keyword, `<span style="color: red">${keyword}</span>`)
              text = `${name}(${enName})`
            } else {
              text = `${name}`
            }
          }
          return text
        })
        let html = ''
        if (htmlArr.length > 1) {
          html = htmlArr.join(' / ')
        } else {
          html = htmlArr.join('')
        }

        let newArr = {
          key: arr.map(item => item[fieldKey]).join('/'),
          html
        }
        return newArr
      })
    }
  },
  // watch: {
  //   visible (val) {
  //     if (val && this.showSearch) {
  //       setTimeout(() => {
  //         this.$refs.searchInput.focus()
  //       }, 10)
  //     }
  //   }
  // },
  watch: {
    visible (val) {
      if (val) {
        // this.value1 = this.defaultValue.concat([])
        this.initRoutes(this.defaultValue, true)
      }
    }
  },
  async created () {
    const unwatch = this.$watch('visible', function () {
      this.initRoutes(this.defaultValue, true)
      unwatch()
    })
  },
  methods: {
    hide () {
      this.visible = false
    },
    show () {
      this.visible = true
    },
    visibleChangeHandle (val) {
      if (this.disabled) {
        this.visible = false
        return
      }
      if (val && this.showSearch) {
        setTimeout(() => {
          this.$refs.searchInput.focus()
        }, 10)
      }
    },
    async searchHandle (keyword) {
      this.isSearch = true
      this.loading = true
      const { language = 0 } = this
      if (keyword) {
        this.searchLists = await this.searchData({ keyword, language })
        if (!this.searchLists.length) {
          if (this.reportSearch.toString() === 'function _default() {}') {
            this.showReportBox = false
            this.reportSuccess = false
          } else {
            this.showReportBox = true
            this.reportSuccess = false
          }
        }
      }
      this.loading = false
    },
    async clickTagHandle (level) {
      this.isSearch = false
      this.loading = true
      const { language = 0 } = this
      const params = {
        level
      }
      if (level) {
        this.value2 = this.value1.slice(level - 1, level)[0]
        this.value1 = this.value1.slice(0, level - 1)
        this.$emit('change', this.value1.concat(this.value2))
        params.data = this.value2
      } else {
        this.$emit('change', [])
        this.value1 = []
        this.value2 = null
        params.data = null
      }
      params.language = language
      this.lists = await this.getData(params)
      if (this.lists.length && this.value2) {
        this.value1 = this.value1.concat(this.value2)
        this.value2 = null
      }
      this.loading = false
    },
    async clickItemHandle (item) {
      this.isSearch = false
      this.value2 = item
      const { language = 0 } = this
      this.$emit('change', this.value1.concat(this.value2))
      if (!this.hasChild(item)) {
        if (this.hideOnComplete) {
          this.visible = false
        }
        this.$emit('complete', this.value1.concat(this.value2))
        return
      }
      this.loading = true
      const level = this.value1.length + 1
      const lists = await this.getData({
        level,
        data: item,
        language
      })
      if (lists && lists.length) {
        this.lists = lists
        this.value2 = null
        this.value1 = this.value1.concat(item)
      } else {
        this.value2 = item
        if (this.hideOnComplete) {
          this.visible = false
        }
        this.$emit('complete', this.value1.concat(this.value2))
      }
      this.loading = false
    },
    async clickSearchItemHandle (item) {
      let newItem = item.map(one => {
        return {
          code: one.code,
          name: one.name.name
        }
      })
      if (this.isSearch) this.$emit('change', newItem)
      this.isSearch = false
      await this.initRoutes(newItem, false)
    },
    async initRoutes (routes, forCreated) {
      this.loading = true
      let defaultIndex = 0
      const { fieldKey } = this
      const { length } = routes
      const { language = 0 } = this
      this.value1 = routes
      this.value2 = null
      if (!length) {
        this.lists = await this.getData({
          data: null,
          level: 0,
          language
        })
        this.loading = false
        return
      }
      // 请求最后一级的数据
      const data = this.getLast(this.value1)
      const lists = await this.getData({
        data,
        level: this.value1.length,
        language
      })
      if (lists && lists.length) {
        this.lists = lists
        defaultIndex = this.lists.findIndex(item => {
          return item[fieldKey] === data[fieldKey]
        })
      } else {
        if (!forCreated) {
          if (this.hideOnComplete) {
            this.visible = false
          }
        }
        if (length > 1) {
          // 请求倒数第二级数据
          const value1 = this.value1 = routes.slice(0, -1)
          const value2 = this.value2 = routes.slice(-1)[0]
          const data = this.getLast(value1)
          this.lists = await this.getData({
            data,
            level: this.value1.length,
            language
          })
          defaultIndex = this.lists.findIndex(item => {
            return item[fieldKey] === value2[fieldKey]
          })
        }
        this.$emit('complete', routes)
        // if (!forCreated) {
        //   if (this.hideOnComplete) {
        //     this.visible = false
        //   }
        //   this.$emit('complete', routes)
        // } else {
        //   if (length > 1) {
        //     // 请求倒数第二级数据
        //     const value1 = this.value1 = routes.slice(0, -1)
        //     const value2 = this.value2 = routes.slice(-1)[0]
        //     const data = this.getLast(value1)
        //     this.lists = await this.getData({
        //       data,
        //       level: this.value1.length
        //     })
        //     defaultIndex = this.lists.findIndex(item => {
        //       return item[fieldKey] === value2[fieldKey]
        //     })
        //   }
        // }
      }
      this.loading = false
      if (defaultIndex > 3) {
        this.$nextTick(function () {
          const { ul } = this.$refs
          if (ul) {
            ul.scrollTop = (defaultIndex - 3) * 32
          }
        })
      }
    },
    getLast (arr = []) {
      const newArr = arr.slice(-1)
      if (newArr.length) {
        return newArr[0]
      }
      return null
    },
    async handleReport () {
      // todo
      let res = await this.reportSearch(this.keyword)
      // console.log(res)
      if (res) {
        this.showReportBox = false
        this.reportSuccess = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$border-color: #ebebeb;
.container {
  // margin: 100px 0 0 100px;
  width: 336px;
  // border: 1px solid $border-color;
  .search ::v-deep {
    position: relative;
    padding: 8px 0;
    text-align: center;
    .ant-input-search-button {
      background: none;
      border: none;
      margin-right: 3px;
      color: #D6D6D6;
      text-shadow: none;
      box-shadow: none;

    }
  }
  .path {
    cursor: pointer;
    padding: 4px 20px;
    border-bottom: 1px solid $border-color;
    .tag,
    .last {
      line-height: 32px;
      font-size: 14px;
      margin-right: 16px;
    }
    .tag {
      color: #5077aa;
    }
    .last {
      cursor: auto;
      color: grey;
    }
  }
  .main {
    padding: 8px 0;
    .fetching {
      height: 256px;
      text-align: center;
      line-height: 200px;
    }
    .empty {
      height: 256px;
      padding-top: 24px;
      text-align: center;
      .logo-icon {
        color: #D6D6D6;
        font-size: 24px;
      }
      .empty-text {
        color: #B3B3B3;
        font-size: 14px;
        line-height: 24px;
      }
      .report-box {
        width: 240px;
        margin: 24px auto 0;
        p {
          font-size: 12px;
          line-height: 24px;
          color: #666;
        }
        .btns {
          margin: 8px 0;
        }
      }
      .report-result {
        width: 240px;
        margin: 24px auto 0;
      }
      .report-success {
        color: #42C27E;
        line-height: 24px;
        font-size: 12px;
      }
    }
    .list {
      height: 256px;
      overflow-y: auto;
    }
    .item {
      position: relative;
      padding: 6px 20px;
      cursor: pointer;
      // line-height: 32px;
      padding-right: 40px;
      border-radius: 4px;
      &:hover {
        background-color: rgba(244, 247, 249, 1);
      }
      &.selected {
        color: #5077aa;
        background-color: rgba(244, 247, 249, 1);
      }
      .en-name {
        word-break: break-all;
      }
    }
    .more {
      color: #dddddd;
      position: absolute;
      top: 5px;
      right: 12px;
    }
  }
}
</style>
